import React from 'react';
import dynamic from 'next/dynamic';
import { defaultProps } from 'prism-react-renderer';
import { Flex, Spacer, Text } from 'vcc-ui';
import lightCodeTheme from '../../utils/code-theme';
import darkCodeTheme from '../../utils/code-theme-dark';

const Highlight = dynamic(import('prism-react-renderer'), { ssr: false });

const codeExample = (variant, theme, rtl) => `<ThemePicker
  direction="${rtl ? 'rtl' : 'ltr'}"
  variant="${theme}"
>
  <Logo type="spreadmark" />
  <Button
    intent="secondary"
    variant="${variant}"
  >
    ${rtl ? 'مرحباً بالعالم' : 'Hello World'}
  </Button>
</ThemePicker>`;

export const Code = ({ variant, theme, rtl }) => {
  const codeTheme = theme === 'light' ? lightCodeTheme : darkCodeTheme;

  return (
    <Flex>
      <Text variant="bates" extend={{ textAlign: 'center' }}>
        Code
      </Text>
      <Spacer size={2} />
      <Highlight
        {...defaultProps}
        theme={{ ...codeTheme }}
        code={codeExample(variant, theme, rtl)}
        language="jsx"
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre
            className={className}
            style={{ ...style, margin: 0, padding: '10px' }}
          >
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span key={i + key} {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </Flex>
  );
};
